import { render, staticRenderFns } from "./EditAnnouncementModal.vue?vue&type=template&id=4af15106&"
import script from "./EditAnnouncementModal.vue?vue&type=script&lang=js&"
export * from "./EditAnnouncementModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAnnouncementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports